import {
	getRecentSearches,
	RECENT_SEARCH_KEY,
	getRecentQueryObject,
	type RecentSearchItem,
} from '@atlassian/search-common/recent-searches';

import { type PrimaryProductKey } from '../../../../common/constants/products';

export const getRecentQueries = (primaryProduct: PrimaryProductKey, userId: string) => {
	const recentSearches = getRecentSearches({
		userId,
		productId: primaryProduct,
		key: RECENT_SEARCH_KEY,
	});
	return recentSearches.map(mapEssentialData);
};

export const mapEssentialData = (value: RecentSearchItem) => {
	const data = getRecentQueryObject(value);
	return {
		id: data.query,
		title: data.query,
		data,
		type: 'recent-query' as const,
	};
};
